module.exports = function getResource(label, vars = []) {
    const resources = {
        sephoraSDUTitle: 'Livraison le jour même illimitée de Sephora',
        gotIt: 'Compris',
        cancelSubscription: 'Annuler l’abonnement',
        wellMissYou: 'Vous allez nous manquer!',
        cancelSubscriptionMsg: 'Si vous annulez maintenant, vous pouvez toujours utiliser votre abonnement actif jusqu’au ',
        cancelTrialMsgStart: 'Si vous annulez maintenant, vous perdrez immédiatement vos avantages et devrez payer ',
        cancelTrialMsgEnd: 'pour les commandes avec la livraison le jour même.',
        nevermind: 'Ça ne fait rien',
        subscriptionCanceled: 'Votre abonnement a été annulé.'
    };
    return resources[label];
};
